import type { FaireProductEntity } from "../../entity_types/product";

export const p_7nxa837bc5: FaireProductEntity = {
  token: "p_7nxa837bc5",
  type: "product",
  name: "Sequin Heart Crossbody Sling Bag for Kids",
  brandToken: "b_3i6pw6vu4j",
  brandName: "Tiny Treats and ZOMI GEMS",
  imageUrl:
    "https://cdn.faire.com/fastly/88d0c59e6cac05dd5b15e91fa93a0857738e60caa738efb09108a9f98087e795.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/97a8fb0e47176fa41fac0c9e0cff766623a89ff14e93478e709b91b1d4e44fc9.jpeg",
    "https://cdn.faire.com/fastly/e2ccd6b30ee2c4aa6802400ae47b849a9fc6db6881fbf4ac1c08d7bee4882e78.jpeg",
    "https://cdn.faire.com/fastly/ee122777049a8262606a72a83864ecf0e7c551a57f27d69ae41199d01fc53eec.jpeg",
    "https://cdn.faire.com/fastly/dc56fde8766f48872c5f6776f316325c14a25d1456317bb579be6c7356b068c1.jpeg",
    "https://cdn.faire.com/fastly/141326efd44a05a4155b3eeb6b2ddf06e7f744aeaa6645a43d127083fbce0646.jpeg",
    "https://cdn.faire.com/fastly/5424dc1f80cdba2625e33f73a3e1a5d55f7920fd019dd4a98fc6d95b51f4ebd9.jpeg",
    "https://cdn.faire.com/fastly/771a95006254931c70ea459c3e3af9fcbaa261fa0f5d7289d09fe06b7e84a699.jpeg",
    "https://cdn.faire.com/fastly/986626a7775eec5d5b746c3b222ce18fe2d56364a9123ddf7efbdce29f7fda71.jpeg",
    "https://cdn.faire.com/fastly/cd70266cb40cec7e9a9e0085683b8f1966c5f6cf68c225f5083255ed92ee6098.jpeg",
    "https://cdn.faire.com/fastly/4bf868464c6580407cd6e41838cdb893f79f5ecc487f194852d0ab669e0b0d0f.jpeg",
    "https://cdn.faire.com/fastly/d639c3f344d608b6c35bad1f069b01c88898ffb81b34861fc4a799bc8e53e758.jpeg",
    "https://cdn.faire.com/fastly/f5e55aea53ce4411aa5ad7a9eefb8044071abc075873ceabd0a2264494fd3255.jpeg",
    "https://cdn.faire.com/fastly/34b58a81dac6e67cf3ccfa04c81005a56be41a469f52aa301e80e4a2e9f296c1.jpeg",
    "https://cdn.faire.com/fastly/b930a45719846dc747338d1229b176bd2a6951eee7d2e5718bd3e1ba9e096b2f.jpeg",
    "https://cdn.faire.com/fastly/7ac8f7ba6ce858f40fdc9abf9fcb15c3131123ecbf22841c586e2d577a1b2d95.jpeg",
    "https://cdn.faire.com/fastly/7f8abf071c75b9e9aaaac4b189f12606ccbf33644407365da28020fe834a1cd5.jpeg",
    "https://cdn.faire.com/fastly/9c7935eecae94f833ed9e6509eae77ff1aba2782b17bf23fdc2ded3da5827498.jpeg",
  ],
  priceDollars: 12,
  description:
    "This Sequin belt bag is the perfect blend of style and convenience! This trendy crossbody accessory features a cute sequin heart on the front, adding a touch of sparkle to any outfit. Designed with kids in mind, the bag boasts a secure zip-around closure, ensuring all their essentials stay safe and easily accessible. The adjustable strap provides a comfortable fit for children of all ages, making it a versatile addition to their wardrobe. Ideal for on-the-go adventures, this sequin heart belt bag is a must-have accessory for every little fashionista.\n\nWeight: 4oz\nSize: 8W x 2W x 5H\nBlet Length: 15in - 22in in diameter",
  tags: [],
  msrpDollars: 24.99,
  inStock: false,
  meta: {
    source: "api",
    importedAt: "2026-03-25T19:26:10.637Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
